
import { Component, Vue, Prop } from "vue-property-decorator";
export default class MainView extends Vue {}
